import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addUsos } from "../../../../../../../../../redux/actions/resolucion";
import UsosForm from "./UsosForm";


const initialValues = {
    usos: "",
    modoEmpleo: "",
    unidad: "",
    cantidad: "",
}

const UsosFormContainer = ({ formValues, open, handleClose }) => {
    const dispatch = useDispatch();
    const [values, setValues] = useState();

    const usos = useSelector((state) => state.resolucion.usosOrigen.data);
    const modosEmpleo = useSelector((state) => state.resolucion.modosEmpleo.data);

    useEffect(() => {
        if (formValues) setValues(formValues);
        else {
            setValues(initialValues);
        }
    }, [formValues])

    const id = values?.index ?? null;

    const handleSubmit = (values) => {

        values.nombreUso = usos.find((v) => (v.id === values.usos))?.nombre;

        values.nombreModoEmpleo = modosEmpleo.find((v) => (v.id === values.modoEmpleo))?.nombre;
        dispatch(addUsos(values, id))
        handleClose();
    }

    return (
        <UsosForm
            open={open}
            handleClose={handleClose}
            handleSubmit={handleSubmit}
            values={values}
            id={id}
        />
    )

}


export default UsosFormContainer;